import React, { useEffect, useState } from 'react';
import StickyMenu from '../../components/common/StickyMenu';
import instructorService from '../../services/instructorService';
import { Container, Row, Col, Tab, Nav, Button, Card, Modal, OverlayTrigger, Tooltip, TabPane } from 'react-bootstrap';
import { Link, useLocation, useHistory } from 'react-router-dom';
import Footer from '../shared/Footer';
import Navbar from '../shared/Navbar';
import SettingsPanel from '../shared/SettingsPanel';
import Sidebar from '../shared/Sidebar';
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';
import cookies from 'js-cookie';
import UserService from '../../services/UserService';
import service, { URI } from '../../services/service';
import CryptoJS from "crypto-js";
import { COURSE_URL } from '../../services/service';
import './styles/AdminViewCourses.css';  // Import updated custom styles
import { Circles } from 'react-loader-spinner';
import GlobalModal from '../shared/GlobalModal';
import moment from 'moment';
import swal from 'sweetalert';
import { useSelector, useDispatch } from 'react-redux';

const languages = [
    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },
];

function AdminViewCourses(props) {
    useEffect(() => {
        UserService.generateToken();
    }, []);

    const currentLanguageCode = cookies.get('i18next') || 'en';
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
    const { t } = useTranslation();

    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr';
        document.title = t('app_title');
    }, [currentLanguage, t]);

    const history = useHistory();
    const location = useLocation();

    const [postsPerPage] = useState(10);
    const [getCourseData, setCourseData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageNumber, setPageNumber] = useState(0);
    const [rating, setRating] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState({});
    const [selectedCourseId, setSelectedCourseId] = useState(null);
    const [courseEditModalShow, setCourseEditModalShow] = useState(false);
    const [coursesLoader, setCoursesLoader] = useState(false);

    let value = useSelector(state => state.inputValue);
    let userId = UserService.getUserid();
    let roleId = 2;

    useEffect(() => {
        if (location.state && location.state.showCourseEditModal && location.state.courseId) {
            setCourseEditModalShow(true);
            setSelectedCourseId(location.state.courseId);
        } else {
            setCourseEditModalShow(false);
            setSelectedCourseId(null);
        }
    }, [location.state]);

    const onClickCourseEdit = (data) => {
        // console.log("data: ", data);

        setSelectedCourse(data);
        setCourseEditModalShow(true);
    }

    const onCloseEditCourseModal = () => {
        history.replace({ ...history.location, state: undefined });
        setCourseEditModalShow(false);
        setSelectedCourse({});
        setSelectedCourseId(null);
    }

    const imageUrls = (url) => {
        if (url == null) {
            return '';
        } else {
            let imagepath = url.replace(/\\/g, "\\\\");
            let imageurl = `${URI.SERVER?._COURSE_URL}/${imagepath}`;
            return imageurl;
        }
    }

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    let currentCourseState = getCourseData.slice(0, 1000);

    const usersPerPage = 8;
    const pagesVisited = pageNumber * usersPerPage;

    const pageCount = Math.ceil(currentCourseState.length / usersPerPage);

    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };

    const [submitHandlerLoading, setSubmitHandlerLoading] = useState({
        isLoading: false
    });
    const [getPageLoading, setPageLoading] = useState(false);


    const CourseDetails = (id, tid) => {
        
        const secretKey = "cdac@123";

        const encodedCourseId = CryptoJS.AES.encrypt(
            `${id}`,
            secretKey
        ).toString();
        const safeEncodedCourseId = encodedCourseId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        const encodedTenantId = CryptoJS.AES.encrypt(
            `${tid}`,
            secretKey
        ).toString();
        const safeEncodedTenantId = encodedTenantId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        history.push(`${process.env.PUBLIC_URL + "/inst-course-details/"}${safeEncodedCourseId}`);
    }

    useEffect(() => {
        courseData();
    }, []);

    const courseData = async () => {
        setPageLoading(true)
        setCoursesLoader(prevState => !prevState)
        try {
            let result = await instructorService.getAllCourses()
            setCourseData(result.data);
            setCoursesLoader(prevState => !prevState)
            setPageLoading(false)
        } catch (e) {
            console.error(e);
            setPageLoading(false)
        }
    }

    const [hovered, setHovered] = useState(false);

    const toggleHover = () => {
        setHovered(true);
    }

    const toggleHover1 = () => {
        setHovered(false);
    }

    const handleContentDependOnDate = (closingDate) => {

        const dateLimit = moment(closingDate);
        const now = moment();

        if (dateLimit.isValid() && dateLimit > now) {

            return true
        }
    };

    const deleteCourse = (cid) => {
        swal({
            title: `${t('swal_title')}`,
            text: `${t('swal_text')}`,
            icon: "warning",
            buttons: [
                t('no_cancel'),
                t('yes_delete')
            ],
            dangerMode: true,
        }).then(function (isConfirm) {
            if (isConfirm) {
                instructorService.courseDelete(cid)
                    .then(async res => {
                        if (res.data === "deleted successfully") {
                            await swal(`${t('delete')}`, `${t('delete_msg')}`, "success");
                            instructorService.getAllCourses()
                                .then(res => {
                                    setCourseData(res.data);
                                })
                        }
                    }).catch(err => {

                    })
            } else {
                swal(`${t('cancel')}`, `${t('safe_msg')}`, "error");
            }
        });
    }

    return (
        <div className="container-scroller">
            <Navbar />
            {/* <StickyMenu /> */}
            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                {
                    getPageLoading &&
                    <div className='modal-loader'>
                        <GlobalModal showModal={getPageLoading} />
                    </div>

                }
                {
                    coursesLoader && (
                        <div
                            style={{
                                position: 'fixed', // Ensures the div stays on top of other content
                                top: 0,
                                left: 0,
                                width: '100vw', // Covers the entire viewport width
                                height: '100vh', // Covers the entire viewport height
                                backgroundColor: 'rgba(255, 255, 255, 0.562)', // Semi-transparent background
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center', // Centers the loading indicator vertically
                                alignItems: 'center', // Centers the loading indicator horizontally
                                zIndex: 999, // Ensures the div is on top of other elements
                            }}
                        >
                            <Circles
                                height={40}
                                width={40}
                                color="#4fa94d"
                                ariaLabel="circles-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                            />
                        </div>
                    )
                }

                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className="page-header">
                            <h3 className="page-title">
                                {t('courses')}
                            </h3>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="!#" onClick={event => event.preventDefault()}>{t('courses')}</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">{t('view_courses')}</li>
                                </ol>
                            </nav>
                        </div>

                        <div className="col-lg-12 grid-margin stretch-card">
                            <div className="card admin-course-card">
                                <div className="row admin-view-courses-container">
                                    {currentCourseState.slice(pagesVisited, pagesVisited + usersPerPage).map((data, i) => {
                                        return (
                                            <div key={i} className='col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4'>
                                                <div className="course-card">
                                                    <Link onClick={() => CourseDetails(data.courseId, 1, data.status)}>
                                                        <div className="course-image-cd">
                                                            <img onMouseOver={toggleHover} onMouseOut={toggleHover1} style={{ backgroundImage: `url(${imageUrls(data.imageUrl)})` }} />
                                                            <span className="badge">Fully Self-Paced Learning</span>

                                                        </div>

                                                    </Link>
                                                    <div className="layer-box"></div>
                                                    {data.userCount == 0 ? <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('del_course')}</Tooltip>}>
                                                        <Link to='#' className="del-button" onClick={() => deleteCourse(data.courseId)}><i className="fas fa-trash-alt" style={{ fontSize: "17px" }}></i></Link>
                                                    </OverlayTrigger> : null}
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip id="tooltip-disabled">{t('update_course')}</Tooltip>
                                                        }>
                                                        <Link
                                                            className="edit-button"
                                                            to="#"
                                                            onClick={() => onClickCourseEdit(data)}
                                                        >
                                                            <i className="fa fa-edit" style={{ fontSize: "17px" }}></i>
                                                        </Link>
                                                    </OverlayTrigger>
                                                    <div className="course-content-cs">
                                                        <h3 className="course-title">{data.courseName}</h3>

                                                        <div className="course-meta">
                                                            <div className="duration" ><i class="fa fa-clock-o" aria-hidden="true"></i>  {data.duration} Days</div>

                                                            <div className="rating">
                                                                <i class="fa fa-id-card-o" aria-hidden="true"></i> 10+2
                                                            </div>
                                                            {data.courseType == "free" ? <><i class='fas fa-money-check'></i>Free </> : <><div className="fees"><i class='fas fa-money-check'></i> ₹{data.courseFee} <br /> ${data.courseForeignFees}</div></>}
                                                        </div>

                                                    </div>
                                                    <div className="course-footer">
                                                        {data.status == "P" ? handleContentDependOnDate(data.closingDate) ?
                                                            <button className="enroll-btn-new" onClick={() => CourseDetails(data.courseId, 1, data.status)} >Active</button>
                                                            : <button className="enroll-btn-closed" onClick={() => CourseDetails(data.courseId, 1, data.status)}>InActive</button>
                                                            : data.status == "D" ?
                                                                <><button className="enroll-btn-closed" onClick={() => CourseDetails(data.courseId, 1, data.status)}>Disabled</button></>
                                                                : data.status == "C" ?
                                                                    <><button className="enroll-btn-new" onClick={() => CourseDetails(data.courseId, 1, data.status)}>New Created</button></>
                                                                    : <><button className="enroll-btn-closed" onClick={() => CourseDetails(data.courseId, 1, data.status)}>Closed</button></>}
                                                    </div>
                                                </div>

                                                {/* <div className="card admin-course-card">
                                                    <div className='overflow'>
                                                        <img src={imageUrls(data.imageUrl)} alt="" className="card-img-top course-img" />
                                                    </div>
                                                    <div className="card-body">
                                                        <h4 className="card-title course-title">{data.courseName}</h4>
                                                        <p className="card-text text-secondary">
                                                            <a href='#' className='btn course-btn' onClick={() => submitHandler(data.courseId)} disabled={submitHandlerLoading.isLoading ? "true" : ""}>
                                                                {submitHandlerLoading.isLoading ? t('loading') : t('course_details')}
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div> */}
                                            </div>
                                        )
                                    })}
                                </div>
                                <Modal
                                    centered
                                    show={courseEditModalShow}
                                    size="xl"
                                    backdrop="static"
                                    onHide={onCloseEditCourseModal}
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title id="contained-modal-title-vcenter" style={{ alignContent: "center" }}>
                                            Select What to Edit
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Row className="edit-modal-row-1">
                                            <Col className="edit-modal-col-1" lg={6}>
                                                <Card
                                                    className="edit-modal-card"
                                                    onClick={() => {
                                                        const courseId = selectedCourseId === null ? selectedCourse?.courseId : selectedCourseId;
                                                        history.push(process.env.PUBLIC_URL + `/UpdateCourse/${courseId}`)
                                                    }}
                                                >
                                                    <Card.Body className="edit-modal-card-body">
                                                        <Row className="align-items-center meta-edit-data">
                                                            <Col xs={8} className="text-column">
                                                                <div className="card-text-header">
                                                                    Edit Course Metadata
                                                                </div>
                                                                <div className="card-text-body">
                                                                    Edit Course Metadata including Course Name, Objective etc.
                                                                </div>
                                                            </Col>
                                                            <Col xs={4} className="logo-column">
                                                                <div className="card-text-logo-area">
                                                                    <img
                                                                        className="card-text-logo"
                                                                        src={process.env.PUBLIC_URL + "/assets/images/schedule-metadata.png"}
                                                                        alt="Course Metadata Logo"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>


                                            </Col>
                                            <Col className="edit-modal-col-2" lg={6}>
                                                <Card
                                                    className="edit-modal-card"
                                                    onClick={() => {
                                                        const courseId = selectedCourseId === null ? selectedCourse?.courseId : selectedCourseId;
                                                        history.push(process.env.PUBLIC_URL + `/UpdateCourseData/UpdateCourseSchedule/${courseId}`)
                                                    }}
                                                >
                                                    <Card.Body className="edit-modal-card-body">
                                                        <Row className="align-items-center meta-edit-data">
                                                            <Col xs={8} className="text-column">
                                                                <div className="card-text-header">
                                                                    Edit Course Schedule
                                                                </div>
                                                                <div className="card-text-body">
                                                                    Edit Course Schedule: <br /> Course Start Date, Enrollemnt Start Date and End Date
                                                                </div>
                                                            </Col>
                                                            <Col xs={4} className="logo-column">
                                                                <div className="card-text-logo-area">
                                                                    <img
                                                                        className="card-text-logo"
                                                                        src={process.env.PUBLIC_URL + "/assets/images/schedule-calendar.png"}
                                                                        alt="Course Metadata Logo"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row className="edit-modal-row-2">
                                            <Col className="edit-modal-col-3" lg={6}>
                                                <Card
                                                    className="edit-modal-card"
                                                    onClick={() => {
                                                        const courseId = selectedCourseId === null ? selectedCourse?.courseId : selectedCourseId;
                                                        history.push(`${process.env.PUBLIC_URL}/UpdateCourseData/ExtendCourseDuration/${courseId}`);
                                                    }}
                                                >
                                                    <Card.Body className="edit-modal-card-body">
                                                        <Row className="align-items-center meta-edit-data">
                                                            <Col xs={8} className="text-column">
                                                                <div className="card-text-header">
                                                                    Extend the Course Duration
                                                                </div>
                                                                <div className="card-text-body">
                                                                    Extend the Course Duration for all. <br /> Will not affect the Course Duration in Certificate.
                                                                </div>
                                                            </Col>
                                                            <Col xs={4} className="logo-column">
                                                                <div className="card-text-logo-area">
                                                                    <img
                                                                        className="card-text-logo"
                                                                        src={process.env.PUBLIC_URL + "/assets/images/schedule-synchronous.png"}
                                                                        alt="Course Metadata Logo"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>

                                                </Card>
                                            </Col>
                                            <Col className="edit-modal-col-4" lg={6}>
                                                <Card
                                                    className="edit-modal-card"
                                                    onClick={() => {
                                                        const courseId = selectedCourseId === null ? selectedCourse?.courseId : selectedCourseId;
                                                        history.push(process.env.PUBLIC_URL + `/UpdateCourseData/ExtendLearnerDuration/${courseId}`)
                                                    }}

                                                >
                                                    <Card.Body className="edit-modal-card-body">
                                                        <Row className="align-items-center meta-edit-data">
                                                            <Col xs={8} className="text-column">
                                                                <div className="card-text-header">
                                                                    Extend Learner Duration.
                                                                </div>
                                                                <div className="card-text-body">
                                                                    Extend the Course Duration for individual Users. <br /> Will not affect the course duration in certificates
                                                                </div>
                                                            </Col>
                                                            <Col xs={4} className="logo-column">
                                                                <div className="card-text-logo-area">
                                                                    <img
                                                                        className="card-text-logo"
                                                                        src={process.env.PUBLIC_URL + "/assets/images/schedule-guestlist.png"}
                                                                        alt="Course Metadata Logo"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>

                                                </Card>
                                            </Col>
                                        </Row>

                                    </Modal.Body>
                                </Modal>


                                <div className="pagination-container">
                                    {currentCourseState.length > 0 && (
                                        <Col md="12" className="text-center">
                                            <ReactPaginate
                                                previousLabel={t('previous')}
                                                nextLabel={t('next')}
                                                pageCount={pageCount}
                                                onPageChange={changePage}
                                                containerClassName={"paginationBttns"}
                                                previousLinkClassName={"previousBttn"}
                                                nextLinkClassName={"nextBttn"}
                                                disabledClassName={"paginationDisabled"}
                                                activeClassName={"paginationActive"}
                                            />
                                        </Col>
                                    )}
                                </div>
                            </div>
                        </div>

                        <SettingsPanel />
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default AdminViewCourses;
